// src/environments/environment.uat.ts
export const environment = {
  production: false,
  apiBaseUrl: 'https://sky-mpi-uat-finance-fa-o2c-autobill.azurewebsites.net/api',
  apiKey: '46J3Us-ZBJJr7olQF7Zk6usrHAsasUVQ6EmKDpqIQ6A7AzFuQ-wQpQ==',
  msal: {
    // clientId: '178acffe-654b-439b-b822-0a46ec9e4d24',
    clientId: '7e89eab7-19da-494b-b416-1ec5729d88a5',
    // authority: 'https://login.microsoftonline.com/906aefe9-76a7-4f65-b82d-5ec20775d5aa/v2.0',
    authority: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237/v2.0',
    // redirectUri: 'https://sky-mpi-uat-finance-wa-o2c-autobill.azurewebsites.net/',
    redirectUri: 'https://uat.o2cautobill.middleware.sky/',
    // logOutURL:
    // 'https://login.microsoftonline.com/906aefe9-76a7-4f65-b82d-5ec20775d5aa/oauth2/v2.0/logout',
    logOutURL: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237/oauth2/v2.0/logout'
  },
  apiScope: 'api://f5e3c13c-ceeb-4d15-9fb8-90949ba04d1e/access_as_user',
  // Development-only passphrase for client-side token encryption.
  // Replace with a secure secret in production and avoid committing it to source control.
  tokenEncryptionKey: 'dev-local-very-strong-passphrase-change-in-prod'
  //  https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237/v2.0/.well-known/openid-configuration
};
